import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';

// Lazy load pages for better performance (code splitting)
const Home = React.lazy(() => import('./pages/Home'));
const AboutUs = React.lazy(() => import('./pages/AboutUs'));
const Events = React.lazy(() => import('./pages/Events'));
const Gallery = React.lazy(() => import('./pages/Gallery'));
const Contact = React.lazy(() => import('./pages/Contact'));
const ContactVendors = React.lazy(() => import('./pages/ContactVendors'));
const Shop = React.lazy(() => import('./pages/Shop'));
const Newsletter = React.lazy(() => import('./pages/Newsletter'));
const Rsvp = React.lazy(() => import('./pages/Rsvp'));
const RsvpComplete = React.lazy(() => import('./pages/Rsvp/RsvpComplete'));
const Ticket = React.lazy(() => import('./pages/Ticket'));
const Organizer = React.lazy(() => import('./pages/Organizer'));
const CheckIn = React.lazy(() => import('./pages/Organizer/CheckIn'));
const NotFound = React.lazy(() => import('./pages/NotFound'));

// Loading fallback component
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh',
    color: 'var(--color-primary)'
  }}>
    <div>Loading...</div>
  </div>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <ErrorBoundary>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/events" element={<Events />} />
              <Route path="/gallery/*" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/contact/vendors" element={<ContactVendors />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/rsvp" element={<Rsvp />} />
              <Route path="/rsvp/complete" element={<RsvpComplete />} />
              <Route path="/ticket/:token" element={<Ticket />} />
              <Route path="/organizer" element={<Organizer />} />
              <Route path="/organizer/checkin" element={<CheckIn />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
        <Footer />
      </div>
    </Router>
  );
}

export default App;

